import TextField from '@material-ui/core/TextField/TextField';
import React, { Fragment } from 'react';
import currencyFormatter from 'currency-formatter';
import FieldBase, { IPropsFieldBase } from './Base';

interface IProps extends IPropsFieldBase {
  mask?: 'nospace' | 'phone' | 'money';
}

export default class FieldText extends FieldBase<IProps> {
  private readonly masks: any = {
    nospace: {
      apply: (value: string) => {
        if (!value) return value;

        return value.replace(/\s+/, '');
      },
      clean: (value: string) => value.replace(/\s+/, '')
    },
    phone: {
      apply: (value: string) => {
        if (!value) return value;

        let regexp = /^(\d{0,2})(\d{0,4})(\d{0,4}).*/;

        if (value.length > 10) {
          regexp = /^(\d{0,2})(\d{0,5})(\d{0,4}).*/;
        }

        if (value.length > 11) {
          regexp = /(\d+)(\d{2})(\d{5})(\d{4})$/;
        }

        if (value.length > 11 && value.startsWith('55') && value[4] !== '9') {
          regexp = /(\d+)(\d{2})(\d{4})(\d{4})$/;
        }

        let result = '($1$2$3';

        if (value.length > 2) {
          result = '($1) $2-$3';
        }

        if (value.length > 11) {
          result = '+$1 ($2) $3-$4';
        }

        return value.replace(regexp, result).replace(/-$/, '');
      },
      clean: (value: string) => value.replace(/\D/gi, '').substring(0, 20)
    },
    money: {
      apply: (value: string) => {
        if (!value) return value;

        value = value.toString();

        if (value.match(/^\d+$/)) {
          value = `${value}.00`;
        }

        if (value.match(/^\d+\.\d+$/)) {
          value = Number(value).toFixed(2);
        }

        value = value.replace(/\D+/gi, '');

        const intval = value.substr(0, value.length - 2);
        const cents = value.substr(value.length - 2, 2);

        value = `${intval}.${cents}`;

        return currencyFormatter.format(Number(value), { code: 'BR', precision: 2 });
      },
      clean: (value: string) => value
    }
  };

  componentDidMount() {
    this.forceIsValid();
  }
  moveCaretToEnd(el: any) {
    if (!el) {
      return;
    }

    if (el.createTextRange) {
      const range = el.createTextRange();
      range.move('character', el.value.length);
      range.select();
      return;
    }

    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(el.value.length, el.value.length);
      return;
    }

    el.focus();
  }

  onChange(event: any) {
    const value = this.cleanValue(event.target ? event.target.value : event);
    super.onChange(value);

    const target = event.currentTarget;

    setTimeout(() => {
      try {
        this.moveCaretToEnd(target);
      } catch (err) {}
    }, 1);
  }

  getRenderValue(): string {
    const { value, mask } = this.props;

    let newValue = JSON.parse(JSON.stringify(value || ''));

    const maskFunc = this.masks[mask];

    if (maskFunc) {
      newValue = maskFunc.apply(newValue);
    }

    return newValue;
  }

  cleanValue(value: string) {
    const { mask } = this.props;

    const maskFunc = this.masks[mask];
    return !maskFunc ? value : maskFunc.clean(value);
  }

  render() {
    const value = this.getRenderValue();

    return (
      <Fragment>
        {super.render()}

        <TextField
          {...{
            fullWidth: true,
            margin: 'normal',
            ...this.props,
            value: (value === undefined || value === null ? '' : value).toString(),
            error: !!this.errorMessage,
            helperText: <span>{this.errorMessage}</span>,
            onChange: this.onChange.bind(this),
            onBlur: this.onBlur.bind(this),
            submitted: null,
            FormHelperTextProps: {
              classes: {
                root: 'field-error',
                error: 'error',
                disabled: 'disabled'
              }
            },
            touched: null
          }}
        />
      </Fragment>
    );
  }
}
